'use strict';

var AuthenticationStore = require('stores/authentication');

var AuthenticationMixin = {
	statics: {
		willTransitionTo: function willTransitionTo(transition) {
			if (!AuthenticationStore.loggedIn) {
				AuthenticationStore.attemptedTransition = transition;
				transition.redirect('/login');
			}
		}
	}
};

module.exports = AuthenticationMixin;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/mixins/authentication.js
 **/